/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";

const Error = () => (
  <>
    <div className="not-found-outer">
      <div className="not-found">
        <h6>Oops! Page not found</h6>
        <h1>
          <span>4</span>
          <span>0</span>
          <span>4</span>
        </h1>
        <h5>
          we are sorry, but the page you
          <br />
          requested was not found
        </h5>
      </div>
    </div>
  </>
);

export default Error;
